module.exports = __webpack_public_path__ + "static/img/SPD.5cb43c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/LogosExperten/Parteien/SPD.png
// module id = 32
// module chunks = 0